// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4k-0";
export var orangeButton = "_4k-1";